import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./Container.module.scss";

type ContainerProps = {
  children?: React.ReactNode;
  withBg?: boolean;
};

const Container = ({ children, withBg }: ContainerProps) => {
  const classes = classNames({
    [styles.container]: true,
    [styles.withBg]: withBg,
  });

  return <div className={classes}>{children}</div>;
};

Container.propTypes = {
  children: PropTypes.node,
  withbg: PropTypes.bool,
};

export default Container;
